export const calculateResizePercentage = (valueFrom, valueTo) => {
    if (!valueFrom || !valueTo)
        return 1;
    const valueFormatFrom = Number(String(valueFrom).replace(/[^0-9]/g, ''));
    const valueFormatTo = Number(String(valueTo).replace(/[^0-9]/g, ''));
    return (valueFormatTo - valueFormatFrom) / valueFormatFrom + 1;
};
export const calculateResizeMargin = (valueFrom, valueTo) => {
    if (!valueFrom || !valueTo)
        return 0;
    const valueFormatFrom = Number(String(valueFrom).replace(/[^0-9]/g, ''));
    const valueFormatTo = Number(String(valueTo).replace(/[^0-9]/g, ''));
    return (valueFormatTo - valueFormatFrom) / 2;
};
